(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7043],{

/***/ 97225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MailPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Mail/LinkButton.tsx



var LinkButton = function LinkButton(_ref) {
  var children = _ref.children,
      url = _ref.url;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkButtonWrapper, {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    children: children
  });
};
var LinkButtonWrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkButton__LinkButtonWrapper",
  componentId: "sc-1d5ecb0-0"
})(["display:flex;align-items:center;justify-content:center;padding:12px 20px 15px;transition:all 0.25s ease;cursor:pointer;background-color:", ";color:#fff;width:300px;height:47px;border:none;border-radius:24px;font-size:17px;font-weight:bold;&:hover{background-color:", ";}@media screen and (max-width:1047px){font-size:18px;width:100%;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(81507);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Mail/index.tsx







 // import { ZenkakuSpace } from '@/components/enpages/Legal/TextStyle'




var MailPage = function MailPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "IR Mail",
      subTitleText: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
      children: "Subscribe IR News Mail"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
      children: ["We will send timely disclosure information, legal disclosure information, etc. to those who have subscribed to our IR News Mail.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We use the e-mail delivery service provided by Magical Pocket Corporation. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "*The site beyond this point is the site of the company's IR News Mail Service."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 50
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkButton, {
      url: "https://www.magicalir.net/141A/irmail_en/index.php",
      children: "Subscribe"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 100
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
      children: "Unsubscribe IR News Mail"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
      children: ["If you wish to unsubscribe from IR News Mail, please click the banner below.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "After your application, you will receive an email with instructions on how to proceed.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "If you wish to change your email address, please unsubscribe and then re-register a new email address."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 50
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkButton, {
      url: "https://www.magicalir.net/141A/irmail_en/stopmail.php",
      children: "Unsubscribe"
    })]
  });
};

MailPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir/'
  }, {
    name: 'IR Mail',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "IR Mail",
      description: "How to apply for and stop IR email distribution.",
      ogp: {
        url: 'en/ir/mail'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/en/ir/mail/index.tsx


/***/ }),

/***/ 45769:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/mail",
      function () {
        return __webpack_require__(97225);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,4123,9774,2888,179], function() { return __webpack_exec__(45769); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);